export const formatNumberWithLimit = (number, digits = 2) => {
  const value = Number(number);
  if (isNaN(value)) return number;
  const format = new Intl.NumberFormat('de-DE', { minimumFractionDigits: digits, maximumFractionDigits: digits });
  return format.format(value);
};

export const reformatNumber = number => {
  return number.replaceAll('.', '').replaceAll(',', '.');
};
